import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router";

/** Az alnézetre mutató linkek `state`-je: annak az oldalnak a neve, ahonnan az olvasó jött.
 *  A history-bejegyzésben utazik, ezért újratöltést és előre–hátra lépkedést is túlél, és
 *  mindig az alatta lévő bejegyzést nevezi meg — új fülön vagy közvetlen linkről nincs. */
export interface BackState {
  back: string;
}

function backLabel(state: unknown): string | null {
  const back = (state as Partial<BackState> | null)?.back;
  return typeof back === "string" && back ? back : null;
}

/** Alnézet-fejléc (design-rendszer 6.): vissza-chevron balra, kontextus-ikon jobbra;
 *  44 px-es célpontokkal. A chevron **tényleges visszalépés**, ha tudjuk, honnan jött az
 *  olvasó (`BackState`): oda visz vissza, a szűrőkkel és a görgetési hellyel együtt, és azt
 *  az oldalt nevezi meg. Előzmény nélkül (közvetlen link, új fül) a `to` / `parent` szülő
 *  oldalra mutat. */
export function SubHeader({
  to,
  parent,
  right,
}: {
  to: string;
  parent: string;
  right?: ReactNode;
}) {
  const navigate = useNavigate();
  const from = backLabel(useLocation().state);
  const className =
    "-ml-2 flex min-h-11 items-center gap-1 rounded-md pl-1 pr-2 text-[14px] font-semibold text-ink";
  return (
    <div className="-mt-1 flex items-center justify-between">
      {from ? (
        <button type="button" onClick={() => navigate(-1)} className={className}>
          <ChevronLeft size={20} />
          {from}
        </button>
      ) : (
        <Link to={to} className={className}>
          <ChevronLeft size={20} />
          {parent}
        </Link>
      )}
      {right}
    </div>
  );
}

export function PageTitle({ children }: { children: ReactNode }) {
  return (
    <h1 className="text-[28px] font-extrabold leading-[1.1] tracking-[-0.01em]">{children}</h1>
  );
}
